var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemTable',_vm._b({ref:"itemTable",attrs:{"disableBulkAction":_vm.tableImportConditions.disableImportUsers,"disableSelectAllItems":_vm.tableImportConditions.disableSelectAllUsers,"disableSelectItems":_vm.tableImportConditions.disableSelectUsers}},'ItemTable',_vm.itemTableProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }